import React from 'react';
import { Card, CardContent, Typography, Avatar, Box } from '@mui/material';
import VoteInfo from './VoteInfo';
import { utcToZonedTime, format } from 'date-fns-tz';
import { parseISO } from 'date-fns';

const VoteDetailsCard = ({
  voter,
  voterAvatarIcon,
  voteDate,
  voteType,
  comment,
  functionName,
  recommendation,
  isVotingPage,
  region
}) => {
  return (
    <Card elevation={4}>
      <CardContent>
        {
          voter && voteDate && (
            <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" gap={2} alignItems="center" minWidth={240}>
            <Avatar src={voterAvatarIcon} alt={voter} sx={{ width: 32, height: 32 }}>
              {!voterAvatarIcon && voter
                ? voter
                    .split(' ')
                    .map((name) => name.charAt(0).toUpperCase())
                    .slice(0, 2)
                    .join('')
                : ''}
            </Avatar>
            <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
              {voter || '--'}
            </Typography>
          </Box>
          {
            voteDate?
            <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              flexGrow: 1,
              textAlign: 'right'
            }}>
            {format(utcToZonedTime(parseISO(voteDate), 'UTC'), 'MMM d, yyyy · h:mm a', {
              timeZone: 'UTC'
            })} UTC
          </Typography>:
          <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            flexGrow: 1,
            textAlign: 'right'
          }}>
          No Date available
        </Typography>
          }
        </Box>
          )
        }
        
        <Box pl={7} pt={1}>
          <VoteInfo
            voteType={voteType}
            comment={comment}
            functionName={functionName}
            recommendation={recommendation}
            isVotingPage={isVotingPage}
            region={region}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default VoteDetailsCard;
